<template lang="pug">
  div.map-container.geo.map-objects
    div.toolbar
      div.line
        h1.title Карта

    div.new-map
      div(ref="map" v-once).bigmap#map

      transition(name="fade")
        div.legend.legend--objects.cuscroll(:class="showMapLegend ? 'open' : 'close'")
          div(v-if="layersLoading").hover-on-loading
          e-perfect-scrollbar
            div.head(@click="showMapLegend = !showMapLegend")
              h2.title Слои
              //span.toolbar-filter__close
              span.legend__close(v-if="showMapLegend")
              span.legend__open(v-else)
            div(v-for="item, name in layersConf" :class="'type-group ' + item.menuClass")
              div.type
                label.checked
                  input.checkbox(type="checkbox" @change="onLayersChange(item, name)" v-model="layers" :value="name")
                  span
                  span.marker {{item.label}}
                label.new-check
                  input.new-checkbox(type="checkbox")
                  span
              template(v-if="item.groups" v-for="groupItem, groupItemName in item.groups")
                div(v-if="groupItem && !groupItem.hideFromMenu").group
                  div(:class="'type ' + groupItem.menuClass")
                    label.checked
                      input.checkbox(type="checkbox" @change="onLayersChange(groupItem, groupItemName, name)" v-model="layers" :value="groupItemName")
                      span
                      span.marker {{groupItem.label}}

    router-view

</template>

<script>
  import objectsMixin from '../mixins/objects-mixin'
  import {map as mapEndpoints } from '../../../api/api-endpoints.js'

  export default {
    name: 'objects',
    mixins: [objectsMixin],
    methods: {
      getLayersConf () {
        return {
          gs: {
            menuClass: 'oth',
            label: 'Отходообразователи',
            endpoint: mapEndpoints.source,
            className: 'cluster-marker',
            iconType: 'wasteCreators',
            groups: {
              legalEntities: {
                menuClass: 'oth-legal-entities oth-upOrg',
                iconType: 'legalEntities',
                label: 'Юридические лица',
                restApiOrder: 10
              },
              individuals: {
                menuClass: 'oth-individuals oth-individ',
                iconType: 'individuals',
                label: 'Физические лица',
                restApiOrder: 9
              }
            }
          },
          msn: {
            iconType: 'places',
            menuClass: 'places',
            label: 'Места сбора и накопления',
            endpoint: mapEndpoints.msn,
            className: 'cluster-marker msn',
            groups: {
              container: {
                menuClass: 'places-cont',
                iconType: 'container',
                label: 'Контейнерные площадки',
                restApiOrder: 1
              },
              noContainer: {
                menuClass: 'places-noCont',
                iconType: 'noContainer',
                label: 'Бесконтейнерный сбор',
                restApiOrder: 2
              },
              separate: {
                menuClass: 'places-points',
                iconType: 'separate',
                label: 'Пункты сбора вторсырья',
                restApiOrder: 3
              }
            }
          },
          dump: {
            iconType: 'svalka',
            menuClass: 'svalka',
            label: 'Несанкционированные свалки',
            endpoint: mapEndpoints.heap,
            className: 'cluster-marker heap',
            groups: {
              heap: {
                menuClass: 'svalka-thrash',
                iconType: 'thrash',
                label: 'Навалы мусора',
                restApiOrder: 1
              },
              unauth: {
                endpoint: mapEndpoints.object,
                menuClass: 'svalka-noThrash',
                iconType: 'noThrash',
                label: 'Несанкционированные ОРО',
                restApiOrder: 2
              }
            }
          },
          object: {
            iconType: 'garbage',
            menuClass: 'obj',
            label: 'Объекты обращения с отходами',
            endpoint: mapEndpoints.object,
            className: 'cluster-marker object',
            groups: {
              process: {
                menuClass: 'obj-obrab',
                iconType: 'process',
                label: 'Объекты обработки',
                restApiOrder: 2
              },
              util: {
                menuClass: 'obj-utiliz',
                iconType: 'util',
                label: 'Объекты утилизации',
                restApiOrder: 5
              },
              neutral: {
                menuClass: 'obj-obezvr',
                iconType: 'neutral',
                label: 'Объекты обезвреживания',
                restApiOrder: 3
              },
              storage: {
                menuClass: 'obj-chran',
                iconType: 'storage',
                label: 'Объекты хранения',
                restApiOrder: 4
              },
              burial: {
                menuClass: 'obj-zachoron',
                iconType: 'burial',
                label: 'Объекты захоронения',
                restApiOrder: 6
              }
            }
          },
          transport: {
            menuClass: 'transp',
            label: 'Транспортировщики',
            endpoint: mapEndpoints.transport,
            className: 'cluster-marker transport',
            iconType: 'transp',
            groups: {
              trans: {
                hideFromMenu: true,
                iconType: 'transport',
                label: 'Транспортировщики',
                restApiOrder: 1
              }
            }
          }
        }
      }
    }
  }
</script>
